import { gql } from '@apollo/client';

export const DELETE_LOCATION_MUTATION = gql`
  mutation DeleteLocation($id: uuid!) {
    delete_locations(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;
